import React from 'react';
import { Alert, Switch, Button, Typography, Space } from 'antd';
import RagQueryRewriteAdvancedOptions from '../../../components/collections/RagQueryRewriteAdvancedOptions';

const { Text } = Typography;

export default function WidgetLlmSettingPanel({
  alertProps,
  enabled,
  onEnabledChange,
  enabledLabel,
  picker,
  cloudProviders,
  navigate,
  sectionTitle,
  modelStepLabel,
  disabled = false,
  saveLoading = false,
  onSave,
  saveLabel = 'Save settings',
}) {
  const pickerDisabled = disabled || !enabled || saveLoading;

  return (
    <Space direction="vertical" style={{ width: '100%' }} size="middle">
      {alertProps && <Alert showIcon type="info" {...alertProps} />}
      <div>
        <Text strong>{enabledLabel}</Text>
        <div style={{ marginTop: 8 }}>
          <Switch checked={enabled} onChange={onEnabledChange} disabled={disabled} />
        </div>
      </div>
      <div className="create-collection-rag-rewrite-advanced">
        <RagQueryRewriteAdvancedOptions
          compact
          hideMaxMessages
          sectionTitle={sectionTitle}
          modelStepLabel={modelStepLabel}
          maxMessages={10}
          onMaxMessagesChange={() => {}}
          picker={picker}
          cloudProviders={cloudProviders}
          navigate={navigate}
          disabled={pickerDisabled}
        />
      </div>
      {onSave && (
        <Button type="primary" loading={saveLoading} onClick={onSave} disabled={disabled}>
          {saveLabel}
        </Button>
      )}
    </Space>
  );
}
